import { getImageBase64, getBackground, getThemePic } from "@/views/home/slidePPT/use/methods";

const nodule = async (data) => {
  const node = data.node;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);
  const imgsrcList = await getImageBase64(node.title, 3);
  const background = await getBackground(data?.customTheme)


  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "Ch_GJIzbVs",
        width: 160.32668963254594,
        height: 161.5498687664042,
        left: 285.8772965879265,
        top: 252.2835465879265,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "RIWYvg1jUE",
        width: 221.39033792650918,
        height: 223.07939632545933,
        left: 464.2940452755905,
        top: 281.0105807086614,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Wk6NoC5mhf",
        width: 141.22162073490813,
        height: 141.22162073490813,
        left: 433.7675524934383,
        top: 124.10999015748031,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "aZInzkJrXP",
        width: 227.87048884514437,
        height: 201.59375,
        left: 44.21833989501312,
        top: 222.3991961942257,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: right;"><span style="font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[1].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "hx2HzISb9e",
        width: 820.500997375328,
        height: 57.5,
        left: 89.74950131233598,
        top: 29.14288713910761,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 25px;"><span style="font-family: Microsoft Yahei;">${node.title || ""
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "WrsyLZYdF4",
        width: 221.74319225721786,
        height: 32.6875,
        left: 50.34563648293963,
        top: 182.6020341207349,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: right;"><strong><span style="font-size: 24.21875px;"><span style="font-family: Microsoft Yahei;">${node.children[1].title || ""
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "TU49CcXvwC",
        width: 256.0594652230971,
        height: 105.59375,
        left: 598.8153707349081,
        top: 161.70374015748033,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[0].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "Wooe7qkAhB",
        width: 221.74319225721786,
        height: 32.6875,
        left: 598.8153707349081,
        top: 124.10999015748031,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 24.21875px;"><span style="font-family: Microsoft Yahei;">${node.children[0].title || ""
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "zBhG29AEEO",
        width: 263.6852854330709,
        height: 81.59375,
        left: 707.1450131233596,
        top: 391.8334153543307,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[2].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "UNb_cOhxtH",
        width: 221.74319225721786,
        height: 32.6875,
        left: 707.1450131233596,
        top: 354.2396653543307,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 24.21875px;"><span style="font-family: Microsoft Yahei;">${node.children[2].title || ""
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "nR9HVsY6gP",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 29.14288057742782,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "7aMOtHGQL_",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 28.90100065616798,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "K-x_oM9Zyl",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 29.041748687664043,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "k0FMpMDXzQ",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 29.777477034120736,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "8csSljinQS",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 29.438484251968504,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "T-015XvyVB",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 38.80282152230971,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "at7U2SFu4N",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 38.560859580052494,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "RYpwFKyEW5",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 38.70168963254593,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "jemaBgMb4C",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 39.437417979002625,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "p0E3mpoy98",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 39.09842519685039,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "d-CWgHTGfj",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 48.4627624671916,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "lJU4o_dLp0",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 48.22080052493438,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "hhTnNQZfQ1",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 48.36154855643044,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "taIUIhdxA5",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 49.09727690288714,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "LdWee_CMvX",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 48.758284120734906,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "IPcn5EbgvK",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 58.122621391076116,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "SNMW0d64NV",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 57.88074146981627,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "aKbol-RLvb",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 58.02148950131234,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "_K5AaXvK-d",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 58.75721784776903,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "PZw0FT8vlF",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 58.418225065616795,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "image",
        id: "Ch2WT7dOOD",
        src: imgsrcList[0],
        width: 123.05232939632546,
        height: 123.05232939632546,
        left: 442.8521981627297,
        top: 133.19463582677164,
        fixedRatio: true,
        rotate: 0,
        clip: {
          shape: "ellipse",
          range: [
            [0, 0],
            [100, 100],
          ],
        },
      },
      {
        type: "image",
        id: "6WE-Dn1Pdc",
        src: imgsrcList[1],
        width: 195.22875656167977,
        height: 195.22875656167977,
        left: 477.37483595800524,
        top: 294.93585958005247,
        fixedRatio: true,
        rotate: 0,
        clip: {
          shape: "ellipse",
          range: [
            [0, 0],
            [100, 100],
          ],
        },
      },
      {
        type: "image",
        id: "XyqlPehcxo",
        src: imgsrcList[2],
        width: 135.45374015748033,
        height: 135.45374015748033,
        left: 298.313812335958,
        top: 265.3316108923884,
        fixedRatio: true,
        rotate: 0,
        clip: {
          shape: "ellipse",
          range: [
            [0, 0],
            [100, 100],
          ],
        },
      },
    ],
    background,
  };
};

export default nodule;
